export const SUBSCRIPTION = 'subscription'
export const LOAD_SUBSCRIPTION_DETAILS = SUBSCRIPTION + '/LOAD_SUBSCRIPTION_DETAILS'
export const RESET_SUBSCRIPTION_DETAILS = SUBSCRIPTION + '/RESET_SUBSCRIPTION_DETAILS'
